import { render, staticRenderFns } from "./ConsultantBanner.vue?vue&type=template&id=35859435&scoped=true"
import script from "./ConsultantBanner.vue?vue&type=script&lang=js"
export * from "./ConsultantBanner.vue?vue&type=script&lang=js"
import style0 from "./ConsultantBanner.vue?vue&type=style&index=0&id=35859435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35859435",
  null
  
)

export default component.exports